import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { EmojiIcon } from '../EmojiIcon';
import styles from './PauseSlideContentV3.css';

const cx = classnames.bind(styles);

function PauseSlideContentV3({ badgeText, heading, description, totalYears, filledSquares, highlightText, spriteVersion }) {
    const yearBlocks = Array.from({ length: totalYears }, (_, index) => {
        if (index < filledSquares) return 'lived';

        return index === filledSquares ? 'today' : 'unknown';
    });

    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <span className={styles.badge}>{badgeText}</span>
                <h2 className={styles.heading}>{heading}</h2>
                <p className={styles.description}>{description}</p>
            </div>
            <div className={styles.lifeGridCard}>
                <div className={styles.lifeGridWrapper}>
                    <div className={styles.lifeGrid}>
                        {yearBlocks.map((status, index) => (
                            <span key={index} className={cx('yearBlock', status)} /> // eslint-disable-line react/no-array-index-key
                        ))}
                    </div>
                    <div className={styles.lifeGridFade} />
                </div>
                <ul className={styles.legend}>
                    <li className={styles.legendItem}>
                        <span className={cx('legendSwatch', 'lived')} />
                        Years lived
                    </li>
                    <li className={styles.legendItem}>
                        <span className={cx('legendSwatch', 'today')} />
                        Today
                    </li>
                    <li className={styles.legendItem}>
                        <span className={cx('legendSwatch', 'unknown')}>?</span>
                        Unknown ahead
                    </li>
                </ul>
            </div>
            <div className={styles.highlightCard}>
                <EmojiIcon name='heart-red' version={spriteVersion} className={styles.highlightIcon} />
                <p className={styles.highlightText}>{highlightText}</p>
            </div>
        </div>
    );
}

PauseSlideContentV3.propTypes = {
    badgeText: PropTypes.node.isRequired,
    heading: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    totalYears: PropTypes.number.isRequired,
    filledSquares: PropTypes.number.isRequired,
    highlightText: PropTypes.node.isRequired,
    spriteVersion: PropTypes.string.isRequired
};

export {
    PauseSlideContentV3
};
